import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

const Customers = () => {
	const theme = useTheme();
	return (
		<Box
			marginBottom={4}
			data-aos={"fade-up"}>
			<Box>
				<Typography
					sx={{
						textTransform: "uppercase",
						fontWeight: "medium",
					}}
					gutterBottom
					color="secondary"
					align="center">
					Trusted by franchise brands across the globe
				</Typography>
			</Box>
			<Box
				display="flex"
				flexWrap="wrap"
				justifyContent="center"
				alignItems="center">
				{[
					"/new-mangomap-assets/svg/anytimefitness.svg",
					"/new-mangomap-assets/svg/foreverlawn.svg",
					"/new-mangomap-assets/svg/bigchicken.svg",
					"/new-mangomap-assets/svg/orangetheory.svg",
					"/new-mangomap-assets/svg/f45training.svg",
					"/new-mangomap-assets/svg/zerolatency.svg",
					"/new-mangomap-assets/svg/1tomplumber.svg",
					"/new-mangomap-assets/svg/crushr.svg",
					"/new-mangomap-assets/svg/janarus.svg",
					"/new-mangomap-assets/svg/stretchzone.svg",
					"/new-mangomap-assets/svg/revl.svg",
				].map((item, i) => (
					<Box
						maxWidth={180}
						marginTop={4}
						marginRight={8}
						key={i}
						className="largeMarginMobile">
						<Box
							component="img"
							width="100%"
							maxHeight="55px"
							src={item}
							alt="Mango Franchise drives their growth."
							sx={{
								filter:
									theme.palette.mode === "dark"
										? "brightness(0) invert(1)"
										: "brightness(0) invert(0) opacity(0.5)",
							}}
						/>
					</Box>
				))}
			</Box>
		</Box>
	);
};

export default Customers;
